/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { reactive } from 'vue'

const notifications = reactive([])

function add({ message, type = 'info', timeout = 4000 }) {
    const id = Date.now() + Math.random()

    notifications.push({ id, message, type })

    if (timeout) {
        setTimeout(() => remove(id), timeout)
    }
}

function remove(id) {
    const index = notifications.findIndex(n => n.id === id)
    if (index !== -1) notifications.splice(index, 1)
}

export function useNotify() {
    return { notifications, add, remove }
}